import { http } from "./http";

export async function getArrivals(dateStr, { updateExisting = true } = {}) {
  // dateStr: "YYYY-MM-DD"
  return (await http.request(`api/flights/arrivals?date=${dateStr}&updateExisting=${updateExisting}`)) || {};
}

export async function getDepartures(dateStr, { updateExisting = true } = {}) {
  return (await http.request(`api/flights/departures?date=${dateStr}&updateExisting=${updateExisting}`)) || {};
}

export async function linkTransfersAndCounts(dateStr) {
  await http.request(`api/flights/linkTransfersAndCounts?date=${dateStr}`, { method: "POST" });
}

export async function getSingleFlight(flightID, flightDate) {
  return (await http.request(`api/flights/singleFlight?flightID=${flightID}&flightDate=${flightDate}`)) || {};
}
